import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {AuthService} from '../../core/auth/auth.service';
import * as firebase from 'firebase/app';
import {isNullOrUndefined} from 'util';
import {Router} from '@angular/router';
import {StateService} from '../../state/state.service';
import {AuthRedirectorService} from '../../core/auth/auth-redirector.service';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit, OnDestroy {

  private user: firebase.User;
  private subscriptions: Subscription[] = [];

  get canResend(): boolean {
    return !isNullOrUndefined(this.user);
  }

  constructor(private auth: AuthService,
              private router: Router,
              private state: StateService,
              private redirector: AuthRedirectorService) {
  }

  ngOnInit(): void {
    // this.subscriptions.push(this.auth.firebaseUser$.subscribe(user => {
    //   if (isNullOrUndefined(user)) {
    //     return;
    //   }
    //   if (user.emailVerified) {
    //     this.subscriptions.push(this.state.state$
    //       .filter(state => state.auth.isAuthenticated)
    //       .first()
    //       .subscribe(() => this.redirector.redirect()));
    //   } else {
    //     this.user = user;
    //   }
    // }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  resend(): void {
    if (this.canResend) {
      this.user.sendEmailVerification();
    }
  }

  login(): void {
    this.auth.logout();
    this.state.state$
      .filter(state => !state.auth.isAuthenticated)
      .first()
      .subscribe(() => this.router.navigate(['login']));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/verify-account/verify-account.component.ts